"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCategories = void 0;
const app_1 = require("@obvio/app");
const react_1 = require("react");
const PRODUCT_CATEGORY_SELECT = { id: true, slug: true, title: true };
function useCategories() {
    const { data: categories, loading } = (0, app_1.useQuery)('getProductCategories', {
        select: PRODUCT_CATEGORY_SELECT,
    });
    return (0, react_1.useMemo)(() => ({ categories, loading }), [categories, loading]);
}
exports.useCategories = useCategories;
